import React, { FC, useState, useEffect } from 'react';
import { ALL_COUNTRY, ALL_STATES } from '../../../../../../constants/countryStateFilter.constants';
import {
  TCountryStateFieldCountryDropdown,
  TCountryStateFieldDropdowns,
  TCountryStateFieldStateDropdown,
} from '../../../../types/countryStateField.types';
import CountryStateDropDown from './dropDown';
import useFirstUserAction from '../../../../hooks/useFirstUserActionState';

const CountryStateDropDowns: FC<TCountryStateFieldDropdowns> = ({
  fields,
  optionsList = [],
  defaultCountry,
  updateSendData,
  useStateCode,
  hideStateProvinceDropdown,
}) => {
  const [countryIndex, setCountryIndex] = useState<number | typeof ALL_COUNTRY>(ALL_COUNTRY);
  const [stateIndex, setStateIndex] = useState<number | typeof ALL_STATES>(ALL_STATES);
  const triggerFirstInteractionGTMEvent = useFirstUserAction();
  const [firstInteractionHappened, setFirstInteractionHappened] = useState(true);
  const [stateValue, setStateValue] = useState<string>('');

  const setInitialState = () => {
    if (optionsList?.length === 1) {
      setCountryIndex(0);
      setStateIndex(ALL_STATES);
      updateSendData({
        country: optionsList[0]?.country || '',
        state: '',
      });
    } else if (defaultCountry) {
      const defaultCountryIndex = optionsList.findIndex((item) => item.country === defaultCountry);
      setCountryIndex(defaultCountryIndex);
      setStateIndex(ALL_STATES);
      updateSendData({
        country: optionsList[defaultCountryIndex]?.country || '',
        state: '',
      });
    } else {
      setCountryIndex(ALL_COUNTRY);
      setStateIndex(ALL_STATES);
      updateSendData({
        country: '',
        state: '',
      });
    }
  };

  useEffect(() => {
    const [country, state] = fields.value.split('|');
    if (!fields.value) {
      setInitialState();
    } else if (
      fields.value &&
      (countryIndex == ALL_COUNTRY ||
        optionsList[countryIndex]?.country !== country ||
        (stateValue !== state && state !== ''))
    ) {
      const selectedCountryIndex = optionsList.findIndex((item) => item.country === country);
      const stateOptions = [...(optionsList?.[selectedCountryIndex]?.states || [])];
      const selectedStateIndex = stateOptions.findIndex(
        (item) => (useStateCode ? item.stateCode : item.state) === state
      );
      setCountryIndex(selectedCountryIndex);
      state && setStateIndex(selectedStateIndex);
      const stateArr = stateOptions[selectedStateIndex];
      const selectedStateValue = useStateCode ? stateArr?.stateCode : stateArr?.state;
      setStateValue(selectedStateValue || '');
      updateSendData({
        country: optionsList[selectedCountryIndex]?.country || '',
        state: selectedStateValue,
      });
    }
  }, [fields.value]);

  const countryOptions: TCountryStateFieldCountryDropdown[] = [...optionsList];

  const stateOptions: TCountryStateFieldStateDropdown[] =
    countryIndex === ALL_COUNTRY ? [] : [...(optionsList?.[countryIndex]?.states || [])];

  useEffect(() => {
    if (!fields.value) {
      setInitialState();
    }
  }, [optionsList, defaultCountry]);

  const handleCountryOptionClick = (newCountrySelectedInd) => {
    setCountryIndex(newCountrySelectedInd);
    setStateIndex(ALL_STATES);
    updateSendData({
      country: optionsList[newCountrySelectedInd]?.country || '',
      state: '',
    });
    if (firstInteractionHappened) {
      triggerFirstInteractionGTMEvent();
      setFirstInteractionHappened(false);
    }
  };

  const handleStateOptionClick = (newStateSelectedInd) => {
    setStateIndex(newStateSelectedInd);
    const stateArr = optionsList?.[countryIndex]?.states?.[newStateSelectedInd];
    updateSendData({
      state: useStateCode ? stateArr?.stateCode : stateArr?.state,
    });
    if (firstInteractionHappened) {
      triggerFirstInteractionGTMEvent();
      setFirstInteractionHappened(false);
    }
  };
  return (
    <>
      {optionsList?.length > 1 && (
        <CountryStateDropDown
          dropdownOptions={countryOptions}
          isCountryDropDown={true}
          handleOptionClick={handleCountryOptionClick}
          selectedOptionInd={countryIndex === ALL_COUNTRY ? '' : optionsList?.[countryIndex]?.country}
          fields={fields}
          label={'cnhi-forms-selector-country'}
          isEnable={true}
        />
      )}

      {!hideStateProvinceDropdown && (
        <CountryStateDropDown
          dropdownOptions={stateOptions}
          handleOptionClick={handleStateOptionClick}
          selectedOptionInd={stateIndex === ALL_STATES ? '' : optionsList?.[countryIndex]?.states?.[stateIndex]?.state}
          fields={fields}
          label={'cnhi-forms-selector-states'}
          isEnable={!!String(stateIndex) && countryIndex !== ALL_COUNTRY && stateOptions?.length !== 1}
        />
      )}
    </>
  );
};

export default CountryStateDropDowns;
